module.exports = __webpack_public_path__ + "img/112.7c8b12cb.jpg";